import { cn } from "@/lib/utils"
import React from "react"
import CodeMirrorInput from "./editor/CodeMirrorInput"
import FormField, { FormFieldProps } from "./FormField"
import { Tooltip } from "../ui/tooltip"
import { Button } from "../ui/button"
// import { GetInputPropsReturnType } from "@mantine/form/lib/types"

interface ExpressionInputProps {
  children: React.ReactNode
  mode: "expression" | "fixed"
  onChangeMode: (mode: "expression" | "fixed") => void
  // value: string
  // onChange: (value: string) => void
  required?: boolean
  // inputProps: GetInputPropsReturnType
  focusToggler?: any
  formFieldProps: Omit<FormFieldProps, "children">
  onRemove?: () => void
}

function ExpressionInput(props: ExpressionInputProps) {
  return (
    <div className="group relative min-h-[60px] flex gap-1.5 items-start">
      <div className={cn("absolute -top-[5px] right-0")}>
        <Tooltip tip={props.mode === "expression" ? "Desactivate expression mode" : "Expression mode"} sideOffset={4}>
          <Button
            variant={"ghost"}
            type="button"
            size="icon"
            className={cn(
              "size-6.5 text-fg-tertiary opacity-0 transition-opacity duration-150 group-hover:opacity-100 ",
              props.mode === "expression" && "text-blue-500 opacity-100",
            )}
            onClick={(e) => {
              props.onChangeMode(props.mode === "expression" ? "fixed" : "expression")
            }}
          >
            <IconGravityUiCurlyBracketsFunction className={""} />
          </Button>
          {/* <ActionIcon
        size={40}
        color="dark"
        variant={"subtle"}
        type="button"
        {...rest}
        className={cn(
          `
            min-h-0 min-w-0

            [&_path]:stroke-[2]

            [&_svg]:size-6
          `,
          rest.className,
        )}
      /> */}
        </Tooltip>
        {/* <Tooltip label={props.mode === "expression" ? "Desactivate expression mode" : "Expression mode"} position="top" openDelay={200}>
          <ActionIcon
            onClick={(e) => {
              props.onChangeMode(props.mode === "expression" ? "fixed" : "expression")
            }}
            color="dark"
            variant={"subtle"}
            size={"md"}
            type="button"
            className={cn(
              " text-fg-tertiary opacity-0 transition-opacity duration-150 group-hover:opacity-100 ",
              props.mode === "expression" && "text-blue-500 opacity-100",
            )}
          >
            <IconGravityUiCurlyBracketsFunction className={"size-[18px]"} />
          </ActionIcon>
        </Tooltip> */}
        {/* <SegmentedControl
                value={props.mode}
                onChange={(value) => {
                    props.onChange(value as "expression" | "fixed")
                }}
                size={"xs"}
                data={[
                    { label: 'Fixed', value: 'fixed' },
                    { label: 'Expression', value: 'expression' },
                ]}
                style={{
                    "--sc-font-size": "10px",
                    "--sc-padding": "1px 6px",
                }}
                className={cn(`
                  opacity-0 transition-opacity duration-150

                  group-hover:opacity-100
                `)}
            /> */}
      </div>
      <div className="flex-1">
        <FormField {...props.formFieldProps}>
          {props.mode === "expression" ? <CodeMirrorInput focusToggler={props.focusToggler} /> : props.children}
        </FormField>
      </div>
      {props.onRemove && (
        <Button
          variant={"ghost"}
          size={"icon"}
          type="button"
          onClick={() => {
            props.onRemove?.()
          }}
          className="absolute top-[27px] right-1.5 size-6.5 opacity-0 group-hover:opacity-100 bg-red-50 hover:bg-red-100"
        >
          <IconHugeiconsDelete02 className={"text-red-500"} />
        </Button>
      )}
    </div>
  )
}

export default ExpressionInput
